export enum TicketStatusesEnum {
    "Open" = 1,
    "In_Progress" = 2,
    "Resolved" = 3,
    "Archived" = 4,
    "Escalate" = 5,
}
